var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import Styles from './check-box-styles.scss';
import React from 'react';
const CheckboxBase = (_a) => {
    var { changeValue } = _a, props = __rest(_a, ["changeValue"]);
    return (React.createElement("div", { "data-testid": `${props.name}-wrap`, className: Styles.inputWrap },
        React.createElement("input", Object.assign({ type: "checkbox" }, props, { placeholder: props.label ? props.placeholder : ' ', "data-testid": props.name, onChange: changeValue }))));
};
export default CheckboxBase;
